export default "__VITE_ASSET__5a377097__"